module.exports = __webpack_public_path__ + "static/media/logonab2.8b8b7f03.png";